<template>
  <div id="app">
    <TravelAccount />
  </div>
</template>

<script>
import TravelAccount from './components/TravelAccount.vue';

export default {
  name: 'App',
  components: {
    TravelAccount
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
